import { updateItemInCollection } from "directus/src/operations";

export async function updateBasicDetails({ item, caseStudyId }) {
    try {
        const query = {
            fields: [
                "id",
                "status",
                "name",
                "project",
                "project_name_alias",
                "date_started",
                "tag_line",
                "team_size",
                "duration",
            ],
        };

        const data = await updateItemInCollection(
            "case_studies",
            caseStudyId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}
